var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex gap-2 items-center"
  }, [_c('canvas', {
    ref: "qrcodeRef",
    attrs: {
      "id": "qrcode"
    }
  }), _c('div', {
    staticClass: "flex flex-col items-center justify-center gap-2 w-[100px] h-[120px]"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.img,
      "alt": "harmony",
      "width": "40"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.item.text))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };